import React, { useEffect } from 'react';
import { useMsal } from '../msalWrapper'; // Import the MSAL context hook
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const Login = () => {
  const { instance, accounts } = useMsal(); // Access the MSAL context
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    const handleLogin = async () => {
      try {
        const loginResponse = await instance.loginRedirect();
        console.log(loginResponse)
      } catch (error) {
        console.error(error)
      }
    }

    if (accounts.length <= 0) {
      handleLogin()
    }

    if (accounts[0]?.username.endsWith("@kubota.com")) {
        MySwal.fire({
        title: "Invalid account",
        text: "Accounts with @kubota.com are not allowed. Please sign in with another account.",
        icon: "warning",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false, 
        confirmButtonText: "OK",
        confirmButtonColor: '#3085d6',
        }).then((result) => {
        if (result.isConfirmed) {
            instance.logoutRedirect();
        }
        });
    }

  }, [accounts, instance, MySwal])

  return (
    <>
    </>
  )
};

export default Login;